// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { TripleCheckInputRequest } from './tripleCheckInputRequest.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class TripleCheckRequestModel {
    'mock'?: boolean;
    'inputModel': TripleCheckInputRequest | null;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof TripleCheckRequestModel>> = [
        {
            "name":     "mock",
            "baseName": "mock",
            "type":     "boolean"
        },
        {
            "name":     "inputModel",
            "baseName": "inputModel",
            "type":     "TripleCheckInputRequest"
        },
    ];

    static getAttributeTypeMap() {
        return TripleCheckRequestModel.attributeTypeMap;
    }
}
